import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';

import { AuthService } from '@auth/auth.service';
import { routes } from '@model/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class SimulatorService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private _isCalculator = false;

  public get isCalculator(): boolean {
    return this._isCalculator;
  }

  public set isCalculator(_isCalculator: boolean) {
    this._isCalculator = _isCalculator;
  }

  public sendPetition(product: string): any {
    return this.http.post<any>(this.apiUrl + routes.sendPetition, {
      productType: product,
      token: this.authService.token,
    });
  }
}
